<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0">GPS Devices</h3>
        </b-card-header>

        <el-table class="table-responsive table"
                  header-row-class-name="thead-light"
                  header-cell-class-name="px-1"
                  cell-class-name="px-1 pointer"
                  table-layout="auto"
                  size="small"
                  fit
                  highlight-current-row
                  :data="devices">
            <el-table-column label="Id"
                             prop="deviceId">
                             <template v-slot="{row}">
                              <router-link :to="{ name:'gpsdevice', params: {id: row._id} }">{{row.deviceId}}</router-link>
                             </template>
            </el-table-column>

            <el-table-column label="Name"
                             prop="name">
            </el-table-column>

            <el-table-column label="Motorbike"
                             prop="motorbike._name">
                             <template v-slot="{row}">
                              <router-link v-if="row.motorbike && row.motorbike._id" :to="{name: 'motorbike', params: {id: row.motorbike._id}}">
                                {{row.motorbike._name}}
                              </router-link>
                             </template>
            </el-table-column>
            <el-table-column label="Autoassign motorbike"
                             prop="autoAssignMotorbike"
                             align="center">
                             <template v-slot="{row}">
                               <i v-bind:class="{ 'ni ni-check-bold': row.autoAssignMotorbike, 'ni ni-fat-remove': !row.autoAssignMotorbike }"/>
                             </template>
            </el-table-column>
        </el-table>

        <!-- TODO: implement pagination -->
        <!-- <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="10" :total="50"></base-pagination>
        </b-card-footer> -->
    </b-card>
</template>
<script>
  import { Table, TableColumn} from 'element-ui'
  import { mapGetters } from 'vuex';
  export default {
    name: 'gpsdevices-table',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    // data() {
    //   return {
    //     currentPage: 1
    //   };
    // },
    computed: {
      ...mapGetters({
        devices: 'gpsdevices/items'
      })
    }
  }
</script>
